import React from 'react';

interface LogoProps {
  className?: string;
  priority?: boolean;
}

const Logo: React.FC<LogoProps> = ({ className = "h-8 w-auto", priority = false }) => {
  return (
    <img 
      src="/logo.svg" 
      alt="Onflow Logo" 
      className={className}
      loading={priority ? "eager" : "lazy"}
    />
  );
};

export default Logo; 
